/* This is custom system .
 * Each constant consists of themeField and propName.
 * Constant name is a fucntionName which will be defined in styled-components function to make the propName available in that comopnent.
 * Look at https://styled-system.com/table for more information.
 */
import { customSystem } from './utils';
export var clickableStyle = customSystem('clickableStyles', 'clickableStyle');
export var cardStyle = customSystem('cardStyles', 'cardStyle');